import { useId } from 'react';
import type { MouseEvent, ReactNode } from 'react';
import { arrowDownIconLg } from '@tpct/icons';

type DisclosureSectionProps = {
  label: ReactNode;
  isExpanded: boolean;
  onToggle: () => void;
  children: ReactNode;
  className?: string;
  labelClassName?: string;
};

const DisclosureSection = ({
  label,
  isExpanded,
  onToggle,
  children,
  className,
  labelClassName,
}: DisclosureSectionProps) => {
  const buttonId = useId();
  const panelId = useId();

  const handleToggle = (event: MouseEvent<HTMLButtonElement>) => {
    event.stopPropagation();
    onToggle();
  };

  return (
    <div className={['tpct-disclosure', className].filter(Boolean).join(' ')}>
      <div
        className={[
          'tpct-disclosure__header',
          isExpanded ? 'tpct-disclosure__header--open' : '',
        ]
          .filter(Boolean)
          .join(' ')}
      >
        <button
          type="button"
          id={buttonId}
          className="tpct-disclosure__toggle"
          onClick={handleToggle}
          aria-expanded={isExpanded}
          aria-controls={panelId}
        >
          <span
            className={['tpct-disclosure__label', labelClassName]
              .filter(Boolean)
              .join(' ')}
          >
            {label}
          </span>
          <span
            className={[
              'tpct-disclosure__icon',
              isExpanded ? 'tpct-disclosure__icon--expanded' : '',
            ]
              .filter(Boolean)
              .join(' ')}
            aria-hidden
          >
            <img src={arrowDownIconLg} alt="" width="24" height="24" />
          </span>
        </button>
      </div>
      {isExpanded ? (
        <div
          id={panelId}
          role="region"
          aria-labelledby={buttonId}
          className="tpct-disclosure__panel"
        >
          {children}
        </div>
      ) : null}
    </div>
  );
};

export default DisclosureSection;
export type { DisclosureSectionProps };
